/** @format — Parse AG-UI stream/state API payloads (single + per-run history) */

import { normalizeAguiComponents } from "./normalizeComponents";

function unwrapStateRoot(stateResponse) {
  const body = stateResponse?.data !== undefined ? stateResponse.data : stateResponse;
  return (
    body?.state ??
    body?.snapshot ??
    body?.agui_state ??
    body?.aguiState ??
    (body && typeof body === "object" && !Array.isArray(body) ? body : null)
  );
}

function componentsFromNode(node) {
  if (!node || typeof node !== "object") return [];
  const raw =
    node.ui_components ??
    node.uiComponents ??
    node.generative_ui ??
    node.generativeUi ??
    node.agui_ui_components ??
    node.agui?.ui_components;
  return normalizeAguiComponents(raw);
}

/**
 * @returns {Array<{ runId?: string, uiComponents: object[] }>}
 */
export function extractRunUiSnapshots(stateResponse) {
  const snap = unwrapStateRoot(stateResponse);
  if (!snap) return [];

  const runLists = [
    snap.runs,
    snap.run_history,
    snap.runHistory,
    snap.message_runs,
    snap.messageRuns,
    snap.agui_runs,
    snap.turns,
    snap.history,
  ].find((x) => Array.isArray(x) && x.length);

  if (runLists) {
    return runLists
      .map((run) => ({
        runId: run.run_id ?? run.runId ?? run.id,
        uiComponents: componentsFromNode(run.snapshot ?? run.state ?? run),
      }))
      .filter((r) => r.uiComponents.length > 0);
  }

  const latest = componentsFromNode(snap);
  if (latest.length) {
    return [{ runId: snap.run_id ?? snap.runId, uiComponents: latest }];
  }

  return [];
}

export function extractLatestUiComponents(stateResponse) {
  const runs = extractRunUiSnapshots(stateResponse);
  if (!runs.length) return [];
  return runs[runs.length - 1].uiComponents;
}
